
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';

import draggable from 'vuedraggable';

import TableActions from '@/components/table/actions';
import columnsResizable from './columnsResizableDirective';

@Component({
  name: 'VTable',
  components: {
    draggable,
    TableActions
  },
  directives: {
    columnsResizable
  }
})
export default class VTable extends Vue {
  @Prop({ default: true }) readonly isShowActions: boolean;
  @Prop() readonly headers: [];
  @Prop() readonly items: [];
  @Prop() readonly filter: any;
  @Prop() readonly tableName: string;
  @Prop() readonly loading: boolean;

  private defaultHeaders = [];
  private editableHeaders = [];
  private thsWidthArray = [];

  private loaded = false;
  private headersTemp: any = null;
  private settingsList = [];
  private defaultFilters = [];
  private headersArrayWidth = [];
  private moving = false;
  private hasResizeListener = false;

  private tables = {};
  private presetsId: any = null;
  private isSavingModalVisible = false;

  // @Watch('headers', {
  //   immediate: true
  // })
  // headersChanged(val) {
  //   console.log('watch headers: ', val);
  // }
  get headersVisible() {
    return this.editableHeaders.filter(item => item.is_visible);
  }
  set headersVisible(val) {
    this.editableHeaders.splice(0, this.editableHeaders.length, ...val);
  }

  get headersEditable() {
    return [...this.headers].filter(item => !item.is_base);
  }

  public onEnd(model) {
    let newHeaders = [...this.headers];
    newHeaders = this.array_move(newHeaders, model.oldIndex, model.newIndex);

    // this.$emit('updateHeaders', newHeaders);

    setTimeout(() => {
      this.$nextTick(() => {
        this.resizeTable(this.$refs.thead, this.$vnode);
      });
    }, 0);
  }

  public array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  }

  public cancel_filter() {
    this.$emit('cancel_filter');
  }

  public changeModalVisible(val) {
    this.isSavingModalVisible = val;
  }

  public changeVisible() {
    this.headersVisible = [...this.headers];
    setTimeout(() => {
      this.$nextTick(() => {
        this.resizeTable(this.$refs.thead, this.$vnode);
      });
    }, 0);
  }
  public resizeTable(el, vnode) {
    // console.log('resizeTable');
    const nodeName = el.nodeName;
    if (['TABLE', 'THEAD'].indexOf(nodeName) < 0) return;

    const table = nodeName === 'TABLE' ? el : el.parentElement;

    const thead = table.querySelector('thead');
    const ths = thead.querySelectorAll('th');

    const barHeight = nodeName === 'TABLE' ? table.offsetHeight : thead.offsetHeight;
    const elem = document.querySelector('.vue-columns-resizable');
    if (elem) {
      elem.parentNode.removeChild(elem);
    }

    table.style.position = 'relative';
    let moving = false;
    let movingIndex = 0;

    const resizeContainer = document.createElement('div');
    resizeContainer.style.width = table.offsetWidth + 'px';
    resizeContainer.style.position = 'relative';
    resizeContainer.className = 'vue-columns-resizable';
    table.parentElement.insertBefore(resizeContainer, table);

    el.querySelectorAll('th').forEach((th, index) => {
      th.style.width = th.offsetWidth + 'px';

      if (index + 1 >= ths.length) return;

      const nextTh = ths[index + 1];
      const bar = document.createElement('div');

      bar.style.position = 'absolute';
      bar.style.left = nextTh.offsetLeft - 4 + 'px';
      bar.style.top = 0;
      bar.style.height = barHeight + 'px';
      bar.style.width = '8px';
      bar.style.cursor = 'col-resize';
      bar.style.zIndex = 1;
      bar.className = 'columns-resize-bar';

      const mousedown = () => {
        moving = true;
        movingIndex = index;
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
      };

      bar.removeEventListener('mousedown', mousedown);
      bar.addEventListener('mousedown', mousedown);

      resizeContainer.appendChild(bar);

      setTimeout(() => {
        this.$nextTick(() => {
          bar.style.left = ths[index + 1].offsetLeft - 4 + 'px';
        });
      }, 0);
    });

    const bars = resizeContainer.querySelectorAll('.columns-resize-bar');

    const mouseup = () => {
      if (!moving) return;

      moving = false;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';

      bars.forEach((bar, index) => {
        const th = ths[index];
        const nextTh = ths[index + 1];
        th.style.width = th.offsetWidth + 'px';
        bar.style.left = nextTh.offsetLeft - 4 + 'px';
        setTimeout(() => {
          this.$nextTick(() => {
            bar.style.left = ths[index + 1].offsetLeft - 4 + 'px';
          });
        }, 0);
      });
      let tempArray = [];
      ths.forEach(item => {
        tempArray.push(item.style.width);
      });
      this.thsWidthArray.splice(0, this.thsWidthArray.length, ...tempArray);
    };
    const checkMouseOut = e => {
      const thead = document.querySelector('thead') ? document.querySelector('thead').getBoundingClientRect() : null;
      if (!thead) {
        return;
      }
      const body = document.body.getBoundingClientRect();

      const offset = thead.top - body.top;
      const offsetBottom = offset + thead.height;

      const mouseOffset = Math.abs(e.clientY) + Math.abs(body.top);

      if (moving && (mouseOffset > offsetBottom || mouseOffset < offset)) {
        moving = false;
      }
    };
    let tempArray = [];
    ths.forEach(item => {
      tempArray.push(item.style.width);
    });
    this.thsWidthArray.splice(0, this.thsWidthArray.length, ...tempArray);
    document.removeEventListener('mouseup', mouseup);
    document.addEventListener('mouseup', mouseup);

    const cutPx = str => +str.replace('px', '');

    const handleResize = e => {
      if (moving) {
        const th = ths[movingIndex];
        const nextTh = ths[movingIndex + 1];
        const bar = bars[movingIndex];

        th.style.width = cutPx(th.style.width) + e.movementX + 'px';
        nextTh.style.width = cutPx(nextTh.style.width) - e.movementX + 'px';
        bar.style.left = nextTh.offsetLeft - 4 + e.movementX + 'px';
      }
    };

    resizeContainer.removeEventListener('mousemove', handleResize);
    resizeContainer.addEventListener('mousemove', handleResize);
    thead.removeEventListener('mousemove', handleResize);
    thead.addEventListener('mousemove', handleResize);
    document.body.removeEventListener('mousemove', checkMouseOut);
    document.body.addEventListener('mousemove', checkMouseOut);

    const handleResizeTable = () => {
      // console.log('handleResizeTable');
      this.resizeTable(el, vnode);
    };

    if (!this.hasResizeListener) {
      this.hasResizeListener = true;
      window.addEventListener('resize', handleResizeTable);
    }
  }

  public saveTable({ name, saveFilters }) {
    let model = {
      headers: this.getHeadersSettings(),
      name,
      is_active: true
    };

    // console.log('model: ', model);

    let updatedTables = {};
    if (saveFilters) {
      model.filter = this.filter;
    }

    let tables = this.tables;
    if (tables) {
      var keys = Object.keys(tables);

      keys.forEach(item => {
        updatedTables[item] = Object.assign({}, tables[item], {
          is_active: false
        });
      });

      updatedTables[model.name] = model;
    } else {
      updatedTables = {
        [model.name]: model
      };
    }

    // console.log('updatedTables: ', updatedTables);

    if (this.presetsId) {
      axios
        .put(`/v2/table/presets/${this.presetsId}`, {
          name: this.tableName,
          type: this.tableName,
          config: JSON.stringify(updatedTables)
        })
        .then(() => {
          this.update();
        });
    } else {
      axios
        .post(`/v2/table/presets`, {
          name: this.tableName,
          type: this.tableName,
          config: JSON.stringify(updatedTables)
        })
        .then(() => {
          this.update();
        });
    }
  }

  public changeTable(name) {
    let tables = this.tables;
    let updatedTables = Object.assign({}, tables);

    // let activeTable;
    this.loaded = false;

    if (updatedTables) {
      var keys = Object.keys(updatedTables);

      keys.forEach(item => {
        updatedTables[item] = Object.assign({}, tables[item], {
          is_active: false
        });
      });

      if (updatedTables[name]) {
        updatedTables[name].is_active = true;
      }
    }

    // console.log('updatedTables: ', updatedTables);

    axios
      .put(`/v2/table/presets/${this.presetsId}`, {
        name: this.tableName,
        type: this.tableName,
        config: JSON.stringify(updatedTables)
      })
      .then(() => {
        this.update();
      });
  }

  public deleteTableSettings(name) {
    let tables = this.tables;

    if (tables && tables[name]) {
      delete tables[name];
    }
    axios
      .put(`/v2/table/presets/${this.presetsId}`, {
        name: this.tableName,
        type: this.tableName,
        config: JSON.stringify(tables)
      })
      .then(() => {
        this.updateTableSettingsList();
      });
  }

  public async update() {
    await this.fetchPresets(this.tableName);
    this.updateTableSettingsList();
    this.updateFilters();
    this.loaded = true;
    // this.updateHeadersWidth();
    // setTimeout(() => {
    //   this.$nextTick(() => {
    //     this.resizeTable(this.$refs.thead, this.$vnode);
    //   })
    // }, 0)
  }

  public updateHeadersWidth() {
    const $tableEl = this.$refs.table;
    let activeTable = null;
    const ths = $tableEl.querySelectorAll('th');
    const tables = this.tables;

    if (tables) {
      var keys = Object.keys(tables);

      keys.forEach(item => {
        if (tables[item].is_active) {
          activeTable = tables[item];
        }
      });

      if (!activeTable || !activeTable.headers || !activeTable.headers.length) {
        return;
      }

      activeTable.headers.forEach((header, index) => {
        ths[index].style.width = header.width;
      });
    }
  }

  public async fetchPresets(name: string) {
    return axios.get(`/v2/table/presets?filter[type]=${name}`).then(response => {
      const presets =
        response.data._embedded.presets && response.data._embedded.presets.length
          ? response.data._embedded.presets
          : null;
      let tables = {};
      // console.log('presets: ', presets);

      if (presets) {
        tables = JSON.parse(presets[0].config);
        // console.log('tables 1: ', tables);

        this.presetsId = presets[0].id;

        let activeTable = null;

        if (tables) {
          var keys = Object.keys(tables);

          keys.forEach(item => {
            if (tables[item].is_active) {
              activeTable = tables[item];
            }
          });

          const headers = (activeTable && activeTable.headers) || this.defaultHeaders;

          this.editableHeaders.splice(0, this.editableHeaders.length, ...headers);

          this.$emit('updateHeaders', activeTable ? activeTable.headers : this.defaultHeaders);
        }
      }
      this.tables = tables;
    });
  }

  public async updateTableSettingsList() {
    if (this.tables) {
      var keys = Object.keys(this.tables);

      this.settingsList = keys.map(item => {
        return {
          name: item,
          is_active: this.tables[item].is_active
        };
      });
    }
  }

  public updateFilters() {
    const tables = this.tables;
    let activeTable;

    if (!tables) {
      return;
    }

    var keys = Object.keys(tables);
    keys.forEach(item => {
      if (tables[item].is_active) {
        activeTable = tables[item];
      }
    });

    if (!activeTable) {
      return;
    }
    if (this.filter) {
      if (JSON.stringify(this.filter) !== JSON.stringify(activeTable.filter)) {
        this.$emit('setFilters', activeTable.filter || this.defaultFilters);
      }
    } else {
      this.$emit('setFilters', activeTable.filter || this.defaultFilters);
    }
  }

  public getHeadersSettings() {
    const headersWidth = this.getHeadersWidth();

    return headersWidth;
  }

  public getHeadersWidth() {
    // let headersArray = [...this.defaultHeaders];
    let headersEditableArray = [...this.editableHeaders];

    headersEditableArray
      .filter(item => item.is_visible)
      .forEach((item, index) => {
        item.width = this.thsWidthArray[index];
      });

    headersEditableArray = this.editableHeaders.map(item => {
      const header = headersEditableArray.find(header => header.id === item.id);
      if (header) {
        return Object.assign({}, item, header);
      }

      return item;
    });

    return headersEditableArray;
  }

  created() {
    this.defaultHeaders = [...this.headers.map(item => Object.assign({}, item))];
    this.editableHeaders = [...this.headers];
    this.defaultFilters = this.filter;
    this.update();
  }
}
